import moment from 'moment'

import { getItemByKeyValue } from '../helpers'

// TODO: Proper typing required here
interface AnomalyRange {
  anomalyDate: any
  dimensions: any[]
  metricActualValue: any
  anomalyDateID: any
  anomalyNotInteresting: any
  metricDifference: any
  metricExpectedValue: any
  explainedAnomaly: any
  selectedRelevantDimensions: any | any[]
  userSuppliedAction: any
  userSuppliedBenefit: any
  userSuppliedCause: any
  userSuppliedEffort: any
}

export function createAnomalyRangeObject(payload: AnomalyRange): object {
  const date = moment(payload.anomalyDate, 'YYYYMMDD').format('DD/MM/YYYY')
  const dimensions = payload.dimensions.slice(0, 3)
  return {
    actual: payload.metricActualValue,
    anomalyDateID: payload.anomalyDateID,
    anomalyNotInteresting: payload.anomalyNotInteresting,
    date,
    difference: payload.metricDifference,
    dimensions,
    expected: payload.metricExpectedValue,
    explainedAnomaly: payload.explainedAnomaly,
    selectedRelevantDimensions: payload.selectedRelevantDimensions,
    userSuppliedAction: payload.userSuppliedAction,
    userSuppliedBenefit: payload.userSuppliedBenefit,
    userSuppliedCause: payload.userSuppliedCause,
    userSuppliedEffort: payload.userSuppliedEffort,
  }
}

export interface AnomaliesState {
  [metricID: string]: {
    dates: string[]
    anomalyRange: Anomaly[]
    metrics: number[]
    metricID: null | string
    upper: number[]
    lower: number[]
    expectedValues: number[]
    callData: {
      loading: boolean
      breakdownLoading: string[]
      error: boolean
    }
    lastRange: {
      to: string
      from: string
      selector: string
    }
    breakdown: any
  }
}

export const defaultAnomalies = {
  dates: [],
  anomalyRange: [],
  metrics: [],
  metricID: null,
  upper: [],
  lower: [],
  expectedValues: [],
  callData: {
    loading: false,
    breakdownLoading: [],
    error: false,
  },
  lastRange: {
    to: '',
    from: '',
    selector: '',
  },
  breakdown: {},
}

export const anomalies = (
  state: AnomaliesState = {},
  action: ReduxAction,
): AnomaliesState => {
  switch (action.type) {
    case 'START_NEW_ANOMALY_DATE_RANGE_SEARCH': {
      const defaultObject = {
        ...defaultAnomalies,
        callData: {
          breakdownLoading: [],
          loading: true,
          error: false,
        },
        lastRange: {
          ...state.lastRange,
        },
        breakdown: {
          ...state.breakdown,
        },
        metricID: action.payload,
      }
      return { ...state, [action.payload]: defaultObject }
    }
    case 'UPDATE_ANOMALY_GRAPH':
      return {
        ...state,
        [action.payload.metricID]: {
          ...defaultAnomalies,
          ...state[action.payload.metricID],
          ...action.payload,
          callData: {
            breakdownLoading: [],
            ...state.callData,
            loading: false,
            error: false,
          },
          lastRange: {
            ...state.lastRange,
            ...action.payload.lastRange,
          },
        },
      }
    case 'FAILED_LOADING_ANOMALY_GRAPH': {
      const defaultObject = {
        ...defaultAnomalies,
        callData: {
          breakdownLoading: [],
          loading: false,
          error: true,
        },
        lastRange: {
          ...state.lastRange,
          ...action.payload.lastRange,
        },
        breakdown: {
          ...state.breakdown,
        },
        metricID: action.payload.metricID,
      }
      return { ...state, [action.payload.metricID]: defaultObject }
    }
    case 'UPDATE_LOADED_ANOMALIES': {
      const { anomalyDate, metricID } = action.payload
      if (
        Object.prototype.hasOwnProperty.call(state, metricID) &&
        Object.prototype.hasOwnProperty.call(state[metricID], 'anomalyRange') &&
        anomalyDate
      ) {
        const {
          anomalyNotInteresting,
          explainedAnomaly,
          selectedRelevantDimensions,
          userSuppliedAction,
          userSuppliedCause,
          userSuppliedEffort,
          userSuppliedBenefit,
        } = action.payload
        const fDate = moment(anomalyDate, 'YYYYMMDD').format('DD/MM/YYYY')
        const found = getItemByKeyValue(
          state[metricID].anomalyRange,
          'date',
          fDate,
        )
        const anomalyRange =
          found === -1
            ? [
                ...state[metricID].anomalyRange,
                { ...createAnomalyRangeObject(action.payload) },
              ]
            : state[metricID].anomalyRange.map((item) => {
                if (item.date === fDate) {
                  return {
                    ...item,
                    anomalyNotInteresting,
                    explainedAnomaly,
                    selectedRelevantDimensions,
                    userSuppliedAction,
                    userSuppliedCause,
                    userSuppliedEffort,
                    userSuppliedBenefit,
                  }
                }
                return item
              })
        const res = {
          ...state,
          [metricID]: {
            ...state[metricID],
            anomalyRange,
          },
        }
        return res
      }
      return {
        ...state,
      }
    }
    default:
      return state
  }
}
